import styled, { css } from "styled-components";

import {
  DropdownListWrapper,
  ListItem,
  SectionTitle,
} from "@FillInTableContainer/shared/styles/dropdown.style";

export const ListWrapper = styled(DropdownListWrapper)``;

export const ListSectionTitle = styled(SectionTitle)``;

export const AiItem = styled(ListItem)<{ $isSelected?: boolean }>`
  ${({ $isSelected }) =>
    $isSelected &&
    css`
      background: var(--Color-Common-Bg-Interactive-Primary-Subtle, #f0f9ff);
    `}
`;
